import { render, staticRenderFns } from "./DentEditMain.vue?vue&type=template&id=1dbb7bb5&scoped=true&"
import script from "./DentEditMain.vue?vue&type=script&lang=js&"
export * from "./DentEditMain.vue?vue&type=script&lang=js&"
import style0 from "./DentEditMain.vue?vue&type=style&index=0&id=1dbb7bb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb7bb5",
  null
  
)

export default component.exports